import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateMarkAnimationSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateMarkAnimationSettingRequest extends Request<IUpdateMarkAnimationSettingParams, IResult> {
  constructor(params: IUpdateMarkAnimationSettingParams) {
    super('updateMarkAnimationEnabledSetting', params);
  }
}
